// extracted by mini-css-extract-plugin
export default {"grupo_input_btn":"Formulario_grupo_input_btn__6KYjn","alerta":"Formulario_alerta__ujk4H","erro":"Formulario_erro__O8-iX"};